export default __webpack_public_path__ + "static/media/az.1549c7ef.jpg";